import type { BrokerCommunication, RelatedEntityType } from "@dune/types";
import { Button } from "@dune/ui";
import { Forward, Reply, ReplyAll } from "lucide-react";
import type { EmailComposerPanelProps } from "../types/panel.types";
import { createEmailTemplate } from "./email-template.utils";

interface CreateEmailActionsProps {
	mail: BrokerCommunication;
	entityId: number;
	entityType: RelatedEntityType;
	replyToEmail: string;
	signature: string | undefined;
	showEmailComposer: (props: EmailComposerPanelProps) => void;
	enabled?: boolean;
}

export const createEmailActionsComponent = ({
	mail,
	entityId,
	entityType,
	replyToEmail,
	signature,
	showEmailComposer,
	enabled = true,
}: CreateEmailActionsProps) => {
	if (!enabled) return null;

	const createHandler = (action: "reply" | "replyAll" | "forward") => () => {
		if (!enabled) return;
		showEmailComposer({
			entityId: entityId,
			entityType: entityType,
			replyTo: replyToEmail,
			initialData: createEmailTemplate(action, mail, signature),
		});
	};

	return (
		<div className="flex space-x-1">
			<Button
				variant="ghost"
				size="icon"
				onClick={createHandler("reply")}
				title="Répondre"
				className="h-6 w-6"
			>
				<Reply size={14} />
			</Button>
			<Button
				variant="ghost"
				size="icon"
				onClick={createHandler("replyAll")}
				title="Répondre à tous"
				className="h-6 w-6"
			>
				<ReplyAll size={14} />
			</Button>
			<Button
				variant="ghost"
				size="icon"
				onClick={createHandler("forward")}
				title="Transférer"
				className="h-6 w-6"
			>
				<Forward size={14} />
			</Button>
		</div>
	);
};
